"use client"

import { useCMSPageContentTracking } from "lib/cms/hooks/useCMSPageContentTracking"
import { useRouter } from "lib/router"
import React, { useEffect } from "react"
import { setUser } from "lib/user"
import type { ImageParams } from "lib/cms/utils"
import { QuizImage } from "../../components/Image/Image"
import {
  titleText,
  descriptionText,
  landingButtonWrapper,
  content,
  contentWrapper,
  imageWrapper,
  container,
} from "./Landing.css"
import { useQuizNavigation } from "../../hooks/useQuizNavigation"
import { blackButton } from "../../Quiz.css"

export type LandingPageData = {
  name: string
  title: string
  description: string
  slug: string
  image: ImageParams
  startCta: string
  metaTitle: string
  metaDescription: string
}

export type QuizProps = {
  data: LandingPageData
  variation: string
  preview: boolean
  experimentId: string
}

export const LandingPage: React.FC<QuizProps> = ({
  data,
  variation,
  preview,
  experimentId,
}) => {
  const { image, title, description, startCta } = data
  const { startQuiz } = useQuizNavigation(0)
  const router = useRouter()

  useCMSPageContentTracking({
    isPreview: preview,
    experimentId,
    variation,
  })

  useEffect(() => {
    if (["mini-bag", "atb-confirmation"].includes(router.query.from)) {
      setUser({ hasClickedQuizLink: true })
    }
  }, [router.query.from])

  return (
    <div className={container}>
      <div className={imageWrapper}>
        <QuizImage src={image.src} title={image.title} alt={image.alt} />
      </div>

      <div className={contentWrapper}>
        <div className={content}>
          <h1 className={titleText}>{title}</h1>
          <p className={descriptionText}>{description}</p>

          <div className={landingButtonWrapper}>
            <button
              data-testid="start-button"
              type="button"
              onClick={startQuiz}
              className={blackButton}
            >
              {startCta}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
